import PropTypes from 'prop-types';
import { Box, Button, Typography, CircularProgress, Slide } from '@mui/material';
import { primaryButtonStyle, secondaryButtonStyle } from 'src/styles/SettingsMenuStyle';

export default function StickySaveBar({ isDirty, onSave, onDiscard, saving }) {
  return (
    <Slide direction="up" in={isDirty} mountOnEnter unmountOnExit>
      <Box
        sx={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 1200,
          bgcolor: '#fff',
          borderTop: '1px solid #e2e8f0',
          px: 3,
          py: 1.5,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 2,
        }}
      >
        <Typography variant="body2" color="text.secondary">
          You have unsaved changes
        </Typography>
        <Button
          variant="outlined"
          onClick={onDiscard}
          disabled={saving}
          sx={secondaryButtonStyle}
        >
          Discard
        </Button>
        <Button
          variant="contained"
          onClick={onSave}
          disabled={saving}
          startIcon={saving ? <CircularProgress size={16} color="inherit" /> : undefined}
          sx={primaryButtonStyle}
        >
          Save changes
        </Button>
      </Box>
    </Slide>
  );
}

StickySaveBar.propTypes = {
  isDirty: PropTypes.bool,
  onSave: PropTypes.func.isRequired,
  onDiscard: PropTypes.func.isRequired,
  saving: PropTypes.bool,
};

StickySaveBar.defaultProps = {
  isDirty: false,
  saving: false,
};
